import { checkHttpStatus, parseJSON, objectToQueryString, expiredToken } from '../../../utils/response';
import { Token, UserCode, Company, EmployeeCode, Worksite, EmployeeId } from '../../../utils/users';
import { errorResponse } from '../../../utils/response';
import { IsEnglish, GetLanguage } from '../../../utils/language';
import { encryption } from '../../../utils/encryption';

export function subCodesTimesheet() {
    let url = 'timesheet/subCodes?' + objectToQueryString({ company: Company(), userCode: UserCode(), worksite: Worksite(), employeeCode: EmployeeCode(), token: Token() });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                let subCodes = response.subCodes;

                //saveProjects(projects);

                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function sortSubCodes(data) {
    return data.sort(function (a, b) {
        const nameA = IsEnglish() ? a.scEn.toLowerCase() : a.scFr.toLowerCase()
        const nameB = IsEnglish() ? b.scEn.toLowerCase() : b.scFr.toLowerCase()
        if (nameA < nameB) //sort string ascending
            return -1
        if (nameA > nameB)
            return 1
        return 0 //default return value (no sorting)
    });
}

export function sortSubCodesByCode(data) {
    return data.sort(function (a, b) {
        const nameA = a.sc
        const nameB = b.sc
        if (nameA < nameB) //sort string ascending
            return -1
        if (nameA > nameB)
            return 1
        return 0 //default return value (no sorting)
    });
}

export function subCodesCCQTimesheet(project, jobTitle, department) {
    let url = 'timesheet/getSubCodeCCQ?' + objectToQueryString({
        userCode: encryption(UserCode()),
        employeeId: encryption(EmployeeId()),
        language: GetLanguage(),
        project: project,
        jobTitle: jobTitle,
        department: department,
        token: Token()
    });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return JSON.parse(response.list);
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function sortSubCodesCCQ(data) {
    return data.sort(function (a, b) {
        const nameA = IsEnglish() ? a.scEn.toLowerCase() : a.scFr.toLowerCase()
        const nameB = IsEnglish() ? b.scEn.toLowerCase() : b.scFr.toLowerCase()
        if (nameA < nameB) //sort string ascending
            return -1
        if (nameA > nameB)
            return 1
        return 0 //default return value (no sorting)
    });
}

export function sortSubCodesByCodeCCQ(data) {
    return data.sort(function (a, b) {
        const nameA = a.sc
        const nameB = b.sc
        if (nameA < nameB) //sort string ascending
            return -1
        if (nameA > nameB)
            return 1
        return 0 //default return value (no sorting)
    });
}